import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal, Steps } from 'antd'
import { STEPS_ITEMS, WECHAT_LINK } from '../homeContent'
import styles from './HomeH5.module.css'

/**
 * 移动端竖版图片配置 - 请将设计好的竖版图片放入 public/img/2025/h5/ 目录
 * 按顺序命名：1.jpg, 2.jpg, 3.jpg ...
 */
const H5_IMAGES = [
    { src: '/img/2025/h5/1.jpg', alt: '1' },
    { src: '/img/2025/h5/2.jpg', alt: '2' },
    { src: '/img/2025/h5/3.jpg', alt: '3' },
    { src: '/img/2025/h5/4.jpg', alt: '4' },
    { src: '/img/2025/h5/5.jpg', alt: '5' },
    { src: '/img/2025/h5/6.jpg', alt: '6' },
    { src: '/img/2025/h5/7.jpg', alt: '7' },
    { src: '/img/2025/h5/8.jpg', alt: '8' },
    { src: '/img/2025/h5/9.jpg', alt: '9' },
    { src: '/img/2025/h5/10.jpg', alt: '10' },
    { src: '/img/2025/h5/11.jpg', alt: '11' },
    { src: '/img/2025/h5/12.jpg', alt: '12' },
    { src: '/img/2025/h5/13.jpg', alt: '13' },
    { src: '/img/2025/h5/14.jpg', alt: '14' },
    { src: '/img/2025/h5/15.jpg', alt: '15' },
    { src: '/img/2025/h5/16.jpg', alt: '16' },
    { src: '/img/2025/h5/17.jpg', alt: '17' },
    { src: '/img/2025/h5/18.jpg', alt: '18' },
    { src: '/img/2025/h5/19.jpg', alt: '19' },
    { src: '/img/2025/h5/20.jpg', alt: '20' },
    { src: '/img/2025/h5/21.jpg', alt: '21' },
    { src: '/img/2025/h5/22.jpg', alt: '22' },
    { src: '/img/2025/h5/23.jpg', alt: '23' },
    { src: '/img/2025/h5/24.jpg', alt: '24' },
    { src: '/img/2025/h5/25.jpg', alt: '25' },
    { src: '/img/2025/h5/26.jpg', alt: '26' },
    { src: '/img/2025/h5/27.jpg', alt: '27' },
    { src: '/img/2025/h5/28.jpg', alt: '28' },
    { src: '/img/2025/h5/29.jpg', alt: '29' },
    { src: '/img/2025/h5/30.jpg', alt: '30' },
]

const TAOBAO_LINK = 'https://item.taobao.com/item.htm?ft=t&id=811175053812'

const NAV_ITEMS = [
    { key: 'top', label: '回到顶部' },
    { key: '2', label: '解决方案' },
    { key: '4', label: '系统价格' },
    { key: '27', label: '立即购买' },
]

function HomeH5() {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [currentStep, setCurrentStep] = useState(0)

    const scrollTo = (target) => {
        if (target === 'top') {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
            const el = document.querySelector(`img[alt="${target}"]`)
            el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    return (
        <div className={styles.page}>
            <header className={styles.header}>
                <span className={styles.logo} onClick={() => navigate('/H5Index')}>
                    伯纳思
                </span>
                <a className={styles.pcLink} href="/" target="_blank" rel="noreferrer">
                    电脑版
                </a>
            </header>

            <div className={styles.imageList}>
                {H5_IMAGES.map(({ src, alt }, index) => {
                    const isLast = index === H5_IMAGES.length - 1
                    const clickable = alt === '28' || isLast
                    const href = alt === '28' ? TAOBAO_LINK : isLast ? WECHAT_LINK : null
                    return (
                        <img
                            key={alt}
                            src={src}
                            alt={alt}
                            onClick={clickable ? () => window.open(href) : undefined}
                            style={clickable ? { cursor: 'pointer' } : undefined}
                        />
                    )
                })}
            </div>

            <div className={styles.ctaSection}>
                <div className={styles.ctaRow} onClick={() => scrollTo('4')} />
                <div className={styles.ctaRow} onClick={() => scrollTo('5')} />
                <div className={styles.ctaRow} onClick={() => window.open(WECHAT_LINK)} />
            </div>

            <nav className={styles.bottomNav}>
                {NAV_ITEMS.map(({ key, label }) => (
                    <div key={key} className={styles.navItem} onClick={() => scrollTo(key)}>
                        {label}
                    </div>
                ))}
            </nav>

            <Modal open={open} onCancel={() => setOpen(false)} footer={null} width="95%" style={{ maxWidth: 400 }}>
                <div style={{ padding: 16 }}>
                    <h2 style={{ textAlign: 'center', marginBottom: 16 }}>定制开发流程</h2>
                    <div className={styles.modalSteps}>
                        <Steps items={STEPS_ITEMS} direction="vertical" current={currentStep} onChange={setCurrentStep} />
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default HomeH5
